<template>
  <div :id="`inbound-email-${inboundEmail.id}`">
    <bookmark-modal modelType="InboundEmail" :modelId="inboundEmail.id"
      :currentValue="inboundEmail.bookmark"></bookmark-modal>

    <div class="card shadow-none">
      <div class="card-body" :class="{ 'pb-0': collapsed }">
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header">
          <div class="tl-l">
            <div class="avatar-xs">
              <span
                class="
                  avatar-title
                  rounded
                  bg-soft-primary
                  text-primary
                  font-size-16
                "
              >
                {{ inboundEmail.email.charAt(0).toUpperCase() }}
              </span>
            </div>
          </div>
          <div class="tl-r">
            <div>
              <span class="name">{{ inboundEmail.email }}</span> emailed us
            </div>
            <small>
              <i>{{ displayTimestamp(inboundEmail.created_at) }}</i>
              <split-tracking-badge v-if="inboundEmail.split_tracking" :split-tracking="inboundEmail.split_tracking" />
            </small>
          </div>
          <div class="tl-actions" v-if="!disableActions">
            <a
              href="#"
              class="btn btn-link text-muted"
              @click.prevent="toggleCollapsed"
            >
              <i
                class="fa"
                :class="{
                  'fa-chevron-down': collapsed,
                  'fa-chevron-up': !collapsed,
                }"
              ></i>
            </a>

            <a href="#" class="btn btn-link text-muted pl-1 pr-1" @click.prevent="openBookmarkModal">
              <i class="fa fa-heart" :class="{
                'text-danger': inboundEmail.bookmark
              }"></i>
            </a>

            <b-dropdown
              variant="white"
              right
              toggle-class="text-muted pt-0 pr-0"
            >
              <template v-slot:button-content>
                <i class="mdi mdi-dots-horizontal font-size-18"></i>
              </template>
              <b-dropdown-item @click="requestDelete" variant="danger"
                >Delete</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r" v-html="inboundEmail.body"></div>
        </div>
        <!-- / tl-wrapper -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Dates from "../../../../../mixins/Dates";
import Forms from "../../../../../mixins/Forms";
import axios from "axios";
import eventBus from "../../../../../event-bus";
import BookmarkModal from './BookmarkModal.vue';
import SplitTrackingBadge from '../../../../../components/SplitTrackingBadge.vue';

export default {
  props: ["inboundEmail", "disableActions"],
  name: "InboundEmail",

  data() {
    return {
      collapsed: false,
    };
  },

  created() {
    eventBus.$on("collapse-all", () => {
      this.collapsed = true;
    });
    eventBus.$on("expand-all", () => {
      this.collapsed = false;
    });
  },

  beforeDestroy() {
    eventBus.$off("collapse-all");
    eventBus.$off("expand-all");
  },

  computed: {
    ...mapGetters("ticketViewer", {
      ticket: "ticket",
    }),
  },

  components: {BookmarkModal, SplitTrackingBadge},

  mixins: [Dates, Forms],

  methods: {
    ...mapActions("ticketViewer", {
      reloadTicket: "reloadTicket",
    }),

    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },

    openBookmarkModal() {
      this.$bvModal.show("bookmark-modal-InboundEmail-" + this.inboundEmail.id);
    },

    requestDelete() {
      let vm = this;
      swal({
        title: "Are you sure you want to delete this note?",
        text: "This cannot be undone.",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete",
        },
        dangerMode: true,
      }).then((shouldDelete) => {
        if (shouldDelete) {
          vm.delete();
        }
      });
    },

    delete() {
      let vm = this;
      vm.isSaving = true;
      axios
        .delete(
          API_BASE +
            "/tickets/" +
            this.ticket.id +
            "/inbound-emails/" +
            this.inboundEmail.id
        )
        .then((r) => {
          vm.isSaving = false;
          vm.reloadTicket();
          this.$notify.success({
            title: "Success!",
            message: "Note deleted successfully",
          });
        })
        .catch((e) => {
          vm.isSaving = false;
          vm.notifyErrors(e);
        });
    },
  },
};
</script>

<style scoped>
.card {
  background-image: linear-gradient(#fef1e1, #fef1e1);
}
</style>
